import { ReactElement } from "react";
import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Chevron({
  outline,
  ...props
}: IconProps): ReactElement {
  return outline ? (
    <Chevron.Outline {...props} />
  ) : (
    <Chevron.Solid {...props} />
  );
}

Chevron.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <path
        d="M4.96409 6.59857C4.63866 6.27313 4.11102 6.27313 3.78558 6.59857C3.46014 6.92401 3.46014 7.45164 3.78558 7.77708L9.41058 13.4021C9.73602 13.7275 10.2637 13.7275 10.5891 13.4021L16.2141 7.77708C16.5395 7.45164 16.5395 6.92401 16.2141 6.59857C15.8887 6.27313 15.361 6.27313 15.0356 6.59857L9.99984 11.6343L4.96409 6.59857Z"
        fill="currentColor"
      />
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Chevron.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <path
        d="M4.96409 6.59857C4.63866 6.27313 4.11102 6.27313 3.78558 6.59857C3.46014 6.92401 3.46014 7.45164 3.78558 7.77708L9.41058 13.4021C9.73602 13.7275 10.2637 13.7275 10.5891 13.4021L16.2141 7.77708C16.5395 7.45164 16.5395 6.92401 16.2141 6.59857C15.8887 6.27313 15.361 6.27313 15.0356 6.59857L9.99984 11.6343L4.96409 6.59857Z"
        fill="currentColor"
      />
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
